export default "__VITE_ASSET__d82447ad__"